import '../common/polyfill';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {Route, Switch} from 'inferno-router';

import {BaseApp} from '../common/components/BaseApp';
import {initConfig} from '../common/config';
import {getRouter, runIfInBrowser, setupAnalytics} from '../common/util';

import {IndexPage} from './IndexPage';
import {StickerDocsPage} from './StickerDocsPage';
import {HomePage} from './HomePage';
import {UnityArGifSdkPage} from './UnityArGifSdkPage';

import '~/assets/scss/ngDialog.min.css';
import '~/assets/scss/ngDialog-theme-default.min.css';
import '~/assets/scss/components/dialog.scss';

import '~/assets/fonts/fonts.css';
import './app.scss';
import '~/assets/dist/iconfont/iconfont.css';

export const PATH = 'gifapi';

class App extends BaseApp {}


/**
 *
 */
function NoMatch() {
    return <div>Not Found</div>;
}

/**
 *
 * @param history
 * @param config
 * @param request
 * @param response
 * @param {jsx.AppGlobals} context
 */
export function routes(history, config, request, response, context) {
    const appGlobals = initConfig(config, PATH, request, response);
    Object.assign(context, appGlobals);
    setupAnalytics({context, fbq: true});

    const routes = <App appGlobals={appGlobals}><Switch>
        <Route exact={true} path={`/${PATH}/`} component={ HomePage }/>
        <Route path={`/${PATH}/documentation`} component={ IndexPage }/>
        <Route path={`/${PATH}/stickers`} component={ StickerDocsPage }/>
        <Route path={`/${PATH}/partner`} component={ IndexPage }/>
        <Route
            path={`/${PATH}/unity-ar-gif-sdk`} component={ UnityArGifSdkPage }/>
        <Route path={`/${PATH}*`} component={ NoMatch }/>
    </Switch></App>;
    return getRouter(routes, history);
}

// Render HTML if in the browser
runIfInBrowser(routes);
